export class DocumentsDataModel {
  public externalId: string;
  public specificCategory: string;
  public startDate: number;
  public endDate?: any;
  public category: string;
  public externalLocation: string;
  public title: string;

  constructor(_documentsData: DocumentsDataModel) {
    this.externalId = _documentsData.externalId;
    this.specificCategory = _documentsData.specificCategory;
    this.startDate = _documentsData.startDate;
    this.endDate = _documentsData.endDate;
    this.category = _documentsData.category;
    this.externalLocation = _documentsData.externalLocation;
    this.title = _documentsData.title;
  }
}
